// frontend/src/config.js

const DEFAULT_LOCAL = 'http://localhost:10000';

// Em producao, usa a mesma origem do frontend por padrao.
const PROD_BACKEND = '';

const isProduction =
  process.env.NODE_ENV === 'production' ||
  window.location.hostname !== 'localhost';

const API_URL =
  process.env.REACT_APP_API_URL ??
  (isProduction ? PROD_BACKEND : DEFAULT_LOCAL);

export default API_URL;
